import {
  Backdrop,
  Chip,
  FormControl,
  Radio,
  RadioGroup,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import React, { useEffect, useRef } from "react";

import "../../../../src/assets/css/material-dashboard_1.css";

import TestRadio from "./TestRadio";

import FormControlLabel from "@mui/material/FormControlLabel";

import { useState } from "react";
import TargettedSelect from "./TargettedSelect";
import BulkSelect from "./BulkSelect";
import Button from "@mui/material/Button";
import BulkSelect1 from "./BulkSelect1";
import { ThemeProvider, createTheme } from "@mui/material";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import NativePickers from "./ScheduleTimeDate";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";
import { common_axios } from "../../../App";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
// import Chip from "@mui/material/Chip";
// import { history } from "redux-first-router";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

import Select from "@mui/material/Select";
import Autocomplete from "@mui/material/Autocomplete";
import TestRadio2 from "./TestRadio2";
import { findAllByDisplayValue } from "@testing-library/react";
import contactfile1 from "../../../file/voice_campaign.xlsx";
import { Link } from "react-router-dom";
import { dateFormatter } from "../../../helper/helper";
import moment from "moment";
import dayjs from "dayjs";
// import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import LyricsIcon from "@mui/icons-material/Lyrics";
import ContactsIcon from "@mui/icons-material/Contacts";
import VoiceChatIcon from "@mui/icons-material/VoiceChat";

export default function VoiceCampaign() {
  const history = useHistory();

  // ...................................Theme Provider....................................//

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });

  const closeschdule = useRef();
  const cuttt = useRef();

  const closeshedule = useRef();

  const [expandedinter, setExpandedinter] = React.useState("panel1");

  // console.log("eeeexxxpppeeennnddeerr", expandedinter);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpandedinter(newExpanded ? panel : false);
  };

  const [buttonDisable, setbuttonDisable] = useState(false);

  const [expanded, setexpanded] = useState(true);
  const [expanded1, setexpanded1] = useState(false);
  const [checkicon, setcheckicon] = useState(false);
  // const [cancleicon, setcancleicon] = useState(false);
  const [radiobutton2, setradiobutton2] = useState();
  const [RadioGroupValues, setRadioGroupValues] = useState();
  // const [RadioGroupValues1, setRadioGroupValues1] = useState();
  const [val, setval] = useState(false);
  const [scheduleTime, setscheduleTime] = useState();
  // const [scheduleDate, setscheduleDate] = useState();

  const [TemplateArray, setTemplateArray] = useState();
  const [open, setOpen] = useState();

  const [Textarea, setTextarea] = useState("");
  const [Textarea1, setTextarea1] = useState("");
  const [Textareadisabled, setTextareadisabled] = useState(false);
  const [senderId, setsenderId] = useState("");
  const [showradioerror, setshowradioerror] = useState(false);
  const [Language, setLanguage] = useState("");
  const [MSG, setMSG] = useState("");
  const [MSR, setMSR] = useState("");
  const [MST, setMST] = useState({});
  const [Bulkselector1, setBulkselector1] = useState("");
  const [Bulkselector, setBulkselector] = useState("");

  // voice campaigm //
  const [voiceplan, setvoiceplan] = useState("");
  // const [CampaignType, setCampaignType] = useState("");
  const [callerid, setcallerid] = useState("");
  const [prompt2, setprompt2] = useState("");
  const [prompt3, setprompt3] = useState("");
  const [disableNext, setdisableNext] = useState(true);
  const [disableNext1, setdisableNext1] = useState(true);
  const [disableNext2, setdisableNext2] = useState(true);
  const [checkicon1, setcheckicon1] = useState(false);
  const [checkicon2, setcheckicon2] = useState(false);
  const [checkicon3, setcheckicon3] = useState(false);
  const [list, setlist] = useState(null);
  const [list2, setlist2] = useState(null);
  const [FilesImage, setFilesImage] = useState(null);
  const [list3, setlist3] = useState(null);
  const [TargettedArray, setTargettedArray] = useState(null);
  const [bulkdata3, setbulkdata3] = useState(null);
  const [bulkdata4, setbulkdata4] = useState(null);
  const [bulkdata5, setbulkdata5] = useState(null);
  const [Olddata, setOlddata] = useState(null);
  const [CalleridArray, setCalleridArray] = useState(null);
  const [TransDTMFArray, setTransDTMFArray] = useState(null);
  const [PhonebookArray, setPhonebookArray] = useState(null);
  const [showtextsuccessofschedule, setshowtextsuccessofschedule] =
    useState(false);
  const [showtextsuccessofschedule1, setshowtextsuccessofschedule1] =
    useState(false);
  const [scheduleDate, setscheduleDate] = useState();
  const [scheduleDate1, setscheduleDate1] = useState();
  const [eventname, seteventname] = useState("");
  const [pairdisable, setpairdisable] = useState(true);
  const [showsendnow, setshowsendnow] = useState(false);
  const [showsendnow1, setshowsendnow1] = useState(false);
  const [voicearray, setvoicearray] = useState([]);
  const [CampaignType, setCampaignType] = useState("");
  const [testcampaign, settestcampaign] = useState("");
  const [value, setValue] = React.useState(null);
  const [selectedDate, setSelectedDate] = React.useState();

  console.log("fdfdddatyerre", voiceplan?.id);
  console.log({ buttonDisable });
  const getvoiceplane = async () => {
    try {
      setOpen(true);
      // alert("working");
      const resvoice = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/obd-types`
      );

      console.log("resvoice", resvoice);

      if (resvoice.data.statusDescription.statusCode == 200) {
        console.log("ccc", resvoice.data.obdCategories);
        setOpen(false);
        setvoicearray(resvoice.data.obdCategories);
      } else {
        setOpen(false);
        toast.error(resvoice.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      // alert("catch block");
      setOpen(false);
      console.log(error);
    }
  };
  const handleBlur = (e) => {
    console.log({ e });
    setSelectedDate(e.target.value);
  };
  console.log("callerarray", Olddata);

  const handleChangeBulk = (value) => {
    // console.log("targeted value", value);
    setlist(value);
  };
  const handleChangeBulk2 = (value) => {
    // console.log("targeted value", value);
    setlist2(value);
  };
  const handleChangeBulk3 = (value) => {
    // console.log("targeted value", value);
    setlist3(value);
  };

  // console.log("vashddddddd", Olddata);

  const firstNext = () => {
    if (checkicon1 == true) {
      setExpandedinter("panel2");
    } else {
      setExpandedinter("panel1");
    }
  };
  const SecondNext = () => {
    if (checkicon2 == true) {
      setExpandedinter("panel3");
    } else {
      setExpandedinter("panel2");
    }
  };
  const ThirdNext = () => {
    if (checkicon3 == true) {
      setExpandedinter(false);
    } else {
      setExpandedinter(false);
    }
  };

  const [Radiosdisabled, setRadiosdisabled] = useState({
    textarea: true,
    bulk: true,
    bulk1: true,
    choose: true,
  });

  console.log("gggg", TransDTMFArray);
  // console.log("gggg", val);
  // console.log("datetimeneie", scheduleTime, scheduleDate);
  // console.log("targatedarrayaaaaaa", FilesImage);
  // console.log("setradiooo", radiobutton);
  // console.log("setradiooo1", Bulkselector1);

  const initialValues = {
    campaignname: "",
    textarea: "",
    textarea1: "",
  };

  const validationSchema = yup.object({
    campaignname: yup
      .string()
      //   .min(1000000000, "Please type atleast 10 digits")
      //   .max(10000000000, "Maximum length of mobile number is 10")
      .required("Required"),
    textarea: yup
      .string()
      //   .min(1000000000, "Please type atleast 10 digits")
      //   .max(10000000000, "Maximum length of mobile number is 10")
      // .required("Required"),
      .nullable(),
    textarea1: yup
      .string()
      //   .min(1000000000, "Please type atleast 10 digits")
      //   .max(10000000000, "Maximum length of mobile number is 10")
      // .required("Required"),
      .nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validateOnChange: false,
    validationSchema: validationSchema,

    onSubmit: async (values) => {
      // console.log("formikvalues3535353", values);
      seteventname(values.campaignname);
      console.log("valueehihihiheihi", values.campaignname);
      if (checkicon == false) {
        // alert("enter");
        // setexpanded(true);
      } else {
        if (radiobutton2 == 1 || radiobutton2 == undefined) {
          if (
            (radiobutton2 == 1 || radiobutton2 == undefined) &&
            RadioGroupValues == 1
          ) {
            // alert("select 1");
            setshowradioerror(false);
            try {
              setOpen(true);

              const formData = new FormData();
              // formData.append("campaignExcel", "");
              formData.append("userId", localStorage.getItem("UserId"));
              formData.append("voicePrompt", Olddata.promptName);
              formData.append("approvalStatus", 0);
              formData.append("username", localStorage.getItem("Username"));
              // formData.append("datetimeEnd", new Date().toJSON().slice(0, 16));
              formData.append(
                "datetimeSecheduled",
                // new Date().toJSON().slice(0, 16)
                moment(new Date())?.format("YYYY-MM-DD hh:mm:ss")
              );
              formData.append("eventName", values.campaignname);
              formData.append("senderId", callerid);
              formData.append("status", "queued");
              formData.append("dst", values.textarea);
              formData.append("type", "final");

              // alert("working");
              const result = await common_axios.post(
                `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/creation`,
                formData
              );
              console.log("resultttttmainnnn", result);
              if (result.data.statusDescription.statusCode == 200) {
                setOpen(false);
                // alert("ok");

                toast.success(result.data.statusDescription.statusMessage, {
                  theme: "colored",
                });
                history.replace("/dashboard/ViewVoiceCampaigns");

                setshowtextsuccessofschedule1(true);
                // setTargettedArray(result?.data?.responseObject);
              } else {
                setOpen(false);
                toast.error(result.data.statusDescription.statusMessage, {
                  theme: "colored",
                });
              }
            } catch (error) {
              // alert("catch block");
              setOpen(false);
              console.log(error);
            }
          } else if (
            (radiobutton2 == 1 || radiobutton2 == undefined) &&
            RadioGroupValues == 2
            // expandedinter === "panel2"
          ) {
            // alert("select 2");
            setshowradioerror(false);
          } else if (
            (radiobutton2 == 1 || radiobutton2 == undefined) &&
            RadioGroupValues == 3
          ) {
            // alert("select 3");
            setshowradioerror(false);
          } else if (
            (radiobutton2 == 1 || radiobutton2 == undefined) &&
            RadioGroupValues == 4
            //   ||
            // RadioGroupValues
          ) {
            // alert("select 4");
            setshowradioerror(false);
            try {
              setOpen(true);

              const formData = new FormData();
              formData.append("campaignExcel", FilesImage);
              formData.append("userId", localStorage.getItem("UserId"));
              formData.append("voicePrompt", Olddata.promptName);
              formData.append("approvalStatus", 0);
              formData.append("username", localStorage.getItem("Username"));
              // formData.append("datetimeEnd", new Date().toJSON().slice(0, 16));
              formData.append(
                "datetimeSecheduled",
                moment(new Date())?.format("YYYY-MM-DD hh:mm:ss")
              );
              formData.append("eventName", values.campaignname);
              formData.append("senderId", callerid);
              formData.append("status", "queued");
              // formData.append("dst", "");
              formData.append("type", "final");

              // alert("working");
              const result = await common_axios.post(
                `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/creation`,
                formData
              );
              // console.log("resultttttmainnnn", result);
              if (result.data.statusDescription.statusCode == 200) {
                setOpen(false);
                // alert("ok");
                toast.success(result.data.statusDescription.statusMessage, {
                  theme: "colored",
                });

                setshowsendnow1(true);

                setshowtextsuccessofschedule1(true);
                history.replace("/dashboard/ViewVoiceCampaigns");
                // setTargettedArray(result?.data?.responseObject);
              } else {
                setOpen(false);
                toast.error(result.data.statusDescription.statusMessage, {
                  theme: "colored",
                });
              }
            } catch (error) {
              // alert("catch block");
              setOpen(false);
              console.log(error);
            }
          } else if (
            radiobutton2 == 1 ||
            (radiobutton2 == undefined && RadioGroupValues == "")
          ) {
            // alert("choose numbers ");
            setshowradioerror(true);
            setexpanded(false);
            setexpanded1(true);
          }
          // else {
          //   // alert("choose numbers ");
          //   setshowradioerror(true);
          //   setexpanded(false);
          //   setexpanded1(true);
          // }
        } else if (radiobutton2 == 2) {
          // alert("radio 2");
          setshowradioerror(false);
          setRadioGroupValues("");
        } else if (radiobutton2 == 3) {
          // alert("radio 3");
          setshowradioerror(false);
          setRadioGroupValues("");
        }
      }
    },
  });
  console.log("hdhhfvsahfka7e", voiceplan);
  const callbackSchedule = (child) => {
    // setscheduleTime(child?.slice("11", "16"));
    // setscheduleDate(child?.slice("0", "10"));
    // console.log(child.target.value, "chillllldddd");
    setscheduleDate(child.target.value);
  };
  const callbackSchedule1 = (child) => {
    // setscheduleTime(child?.slice("11", "16"));
    // setscheduleDate(child?.slice("0", "10"));
    // console.log(child.target.value, "chillllldddd");
    setscheduleDate1(child.target.value);
  };
  const callbackRadio2 = (child) => {
    setradiobutton2(child);
  };

  const handleChangeRadio = (e) => {
    if (e.target.checked == true) {
      setRadioGroupValues(e.target.value);
    }
  };

  const getImage = (e, index) => {
    const img = e.target.files[0];
    // console.log(img, e.target.files[0]);
    // setSelectedImage(img);
    var fileName = e.target.value;
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "xlsx") {
      setFilesImage(img);
    } else {
      toast.error("Only xlsx files are allowed!");
      document.getElementById("fileName").value = "";
    }
  };

  console.log("dhhdidhkdhi", voiceplan.obdCategory);

  const getcallerid = async () => {
    try {
      // alert("fbhsjhfhi");
      setOpen(true);
      // alert("working");
      const rescaller = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/callerId?category=${voiceplan.obdCategory}`
      );
      // console.log("resulttttt", res);
      if (rescaller.data.statusDescription.statusCode == 200) {
        setOpen(false);
        console.log("calleriddididi", rescaller.data);
        setCalleridArray(rescaller?.data?.senderIdModels);
        // setTargettedArray(rescaller?.data?.responseObject);
      } else {
        setOpen(false);
        toast.error(rescaller.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      // alert("catch block");
      setOpen(false);
      console.log(error);
    }
  };

  const getOBD = async () => {
    try {
      // alert("fbhsjhfhi");
      setOpen(true);
      // alert("working");
      const resOBD = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/get/approved/prompt?id=${CampaignType}`
        // {
        //   // campaignType: "DTMF Input OBD",
        //   // campaignCategory: "Transactional",
        //   campaignType: CampaignType,
        //   campaignCategory: voiceplan,
        // }
      );
      console.log("resulttttt", resOBD);
      if (resOBD.data.statusDescription.statusCode == 200) {
        setOpen(false);
        // console.log("calleriddididi", resOBD.data.campaigns[0].obdFileUpload);
        setTransDTMFArray(resOBD?.data?.prompts);
        // setTargettedArray(rescaller?.data?.responseObject);
      } else {
        setOpen(false);
        toast.error(resOBD.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      // alert("catch block");
      setOpen(false);
      console.log(error);
    }
  };

  console.log("shfhskfhsfd dfastgae", scheduleDate, scheduleDate1);

  const scheduleapi = async (e) => {
    e.preventDefault();
    try {
      setOpen(true);

      const formData = new FormData();
      FilesImage ? formData.append("campaignExcel", FilesImage) : <></>;
      formData.append("userId", localStorage.getItem("UserId"));
      formData.append("voicePrompt", Olddata.promptName);
      formData.append("approvalStatus", 0);
      formData.append("username", localStorage.getItem("Username"));
      // formData.append("datetimeEnd", scheduleDate1);
      // formData.append("datetimeSecheduled", scheduleDate);
      formData.append(
        "datetimeSecheduled",
        moment(value?.$d)?.format("YYYY-MM-DD hh:mm:ss")
      );
      formData.append("eventName", formik?.values?.campaignname);
      formData.append("senderId", callerid);
      formData.append("status", "queued");
      formik?.values?.textarea ? (
        formData.append("dst", formik?.values?.textarea)
      ) : (
        <></>
      );
      formData.append("type", "final");

      // alert("working");
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/creation`,
        formData
      );
      // console.log("resultttttmainnnn", result);
      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        // alert("ok");
        closeschdule?.current?.click();
        toast.success(result.data.statusDescription.statusMessage, {
          theme: "colored",
        });

        setshowsendnow(true);

        setshowtextsuccessofschedule(true);
        history.replace("/dashboard/ViewVoiceCampaigns");
        // setTargettedArray(result?.data?.responseObject);
      } else {
        setOpen(false);
        toast.error(result.data.statusDescription.statusMessage, {
          theme: "colored",
        });
        closeschdule?.current?.click();
      }
    } catch (error) {
      // alert("catch block");
      setOpen(false);
      console.log(error);
    }
  };
  // console.log("resSdjkhjkfhkdchedule", moment(new Date()).format("lll"));

  console.log({ Olddata });

  const TestCampaign = async (e) => {
    cuttt?.current?.click();
    e.preventDefault();
    try {
      setOpen(true);

      const formData = new FormData();
      FilesImage ? formData.append("campaignExcel", FilesImage) : <></>;
      formData.append("userId", localStorage.getItem("UserId"));
      formData.append("voicePrompt", Olddata.promptName);
      formData.append("approvalStatus", 0);
      formData.append("username", localStorage.getItem("Username"));
      // formData.append("datetimeEnd", new Date().toJSON().slice(0, 16));
      formData.append("datetimeSecheduled", new Date().toJSON().slice(0, 16));
      formData.append("eventName", formik?.values?.campaignname);
      formData.append("senderId", callerid);
      formData.append("status", "queued");
      formData.append("dst", testcampaign);
      formData.append("type", "Test");
      moment("24/12/2019 09:15:00", "DD MM YYYY hh:mm:ss");
      // alert("working");
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_CAMPAIGN}/voice/v1/voice-campaign/creation`,
        formData
      );
      // console.log("resultttttmainnnn", result);
      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        // alert("ok");
        cuttt?.current?.click();
        toast.success("Campaign Tested Successfully", {
          theme: "colored",
        });

        // setshowsendnow(true);

        // setshowtextsuccessofschedule(true);
        // history.replace("/dashboard/ViewVoiceCampaigns");
        // setTargettedArray(result?.data?.responseObject);
      } else {
        setOpen(false);
        toast.error(result.data.statusDescription.statusMessage, {
          theme: "colored",
        });
        cuttt?.current?.click();
      }
    } catch (error) {
      // alert("catch block");
      cuttt?.current?.click();
      setOpen(false);
      console.log(error);
    }
  };
  useEffect(() => {
    if (MST == undefined) {
      setTextareadisabled(false);
      formik.setFieldValue("textarea1", "", false);
    } else if (MST == null) {
      setMST("");
    } else {
      setTextareadisabled(true);
      formik.setFieldValue("textarea1", MST?.year, false);
    }
  }, [MST]);

  useEffect(() => {
    if (RadioGroupValues == 1) {
      setRadiosdisabled({
        textarea: false,
        bulk: true,
        bulk1: true,
        choose: true,
      });
      setshowradioerror(false);
    } else if (RadioGroupValues == 2) {
      setRadiosdisabled({
        textarea: true,
        bulk: false,
        bulk1: true,
        choose: true,
      });
      setshowradioerror(false);
    } else if (RadioGroupValues == 3) {
      setRadiosdisabled({
        textarea: true,
        bulk: true,
        bulk1: false,
        choose: true,
      });
      setshowradioerror(false);
    } else if (RadioGroupValues == 4) {
      setRadiosdisabled({
        textarea: true,
        bulk: true,
        bulk1: true,
        choose: false,
      });
      setshowradioerror(false);
    }
  }, [RadioGroupValues]);
  useEffect(() => {
    if (Radiosdisabled.choose == true) {
      // alert("run");
      // setFiles("");
      // setFilesImage("No file chosen");
      var str,
        element = document.getElementById("fileName");
      if (element != null) {
        str = element.value = "";
      } else {
        str = null;
      }
    }
  }, [Radiosdisabled]);

  useEffect(() => {
    if (Radiosdisabled.textarea == true) {
      // alert("run");
      setTextarea("");
      formik.setFieldValue("textarea", "", false);
    }
  }, [Radiosdisabled]);

  useEffect(() => {
    if (radiobutton2 != 1 || radiobutton2 != 2) {
      setRadiosdisabled({
        textarea: true,
        bulk: true,
        bulk1: true,
        choose: true,
      });
      setRadioGroupValues("");
      setlist2(null);
      setlist(null);
      setlist3(null);
    }
  }, [radiobutton2]);

  // useEffect(() => {
  //   if (
  //     Radiosdisabled.textarea ||
  //     Radiosdisabled.bulk ||
  //     Radiosdisabled.bulk1 ||
  //     Radiosdisabled.choose == true
  //   ) {
  //     setFilesImage(" ");
  //     // setRadioGroupValues("");
  //     setlist2(null);
  //     setlist(null);
  //     setlist3(null);
  //   }
  // }, [Radiosdisabled]);

  useEffect(() => {
    if (
      (senderId && MSG && MSR && Language) == undefined ||
      formik.values.textarea1 == "" ||
      formik.values.campaignname == ""
    ) {
      // alert("fjbhd");
      // setexpanded(true);
      // setcheckicon({ compose: false });
      setcheckicon(false);
    } else {
      setcheckicon(true);
    }
  }, [
    senderId,
    MSG,
    MSR,
    Language,
    formik.values.textarea1,
    formik.values.campaignname,
  ]);

  useEffect(() => {
    document?.getElementById("area")?.addEventListener("input", function (e) {
      var valueeee = e.target.value;
      var valueeee = valueeee
        ?.replace(/\D/g, "")
        ?.replace(/\B(?=(\d{10})+(?!\d))/g, ",")
        ?.match("^[0-9,]*$");
      // console.log("textarea valueee", valueeee[0]);
      formik.setFieldValue("textarea", valueeee[0], false);
    });
  }, [RadioGroupValues]);

  useEffect(() => {
    if (
      voiceplan == "" ||
      callerid == "" ||
      CampaignType == "" ||
      formik.values.campaignname == ""
    ) {
      setcheckicon1(false);
      setdisableNext(true);
    } else {
      setcheckicon1(true);

      setdisableNext(false);
    }
  }, [voiceplan, CampaignType, callerid, formik.values.campaignname]);

  useEffect(() => {
    if (
      (radiobutton2 == 1 ||
        radiobutton2 == undefined ||
        radiobutton2 == 2 ||
        radiobutton2 == 3) &&
      (list2 != null ||
        list != null ||
        formik.values.textarea != "" ||
        FilesImage != null ||
        list3 != null)
    ) {
      setcheckicon2(true);

      setdisableNext1(false);
    } else if (radiobutton2 == 3) {
      setcheckicon2(true);

      setdisableNext1(false);
    } else {
      setcheckicon2(false);
      setdisableNext1(true);
    }
  }, [radiobutton2, list2, list, formik.values.textarea, FilesImage, list3]);

  useEffect(() => {
    if (Olddata != null) {
      setcheckicon3(true);
      setdisableNext2(false);
    } else {
      setcheckicon3(false);
      setdisableNext2(true);
    }
  }, [Olddata]);

  React.useEffect(() => {
    if (TargettedArray != undefined) {
      const dataarray =
        TargettedArray &&
        TargettedArray?.map((e) => ({
          label: `${e.criteria_name}`,
          userid: `${e.uid}`,
        }));
      setbulkdata3(dataarray);
    } else {
      setbulkdata3([]);
    }
  }, [TargettedArray]);

  React.useEffect(() => {
    if (PhonebookArray != undefined) {
      const dataarrayPhonebook =
        PhonebookArray &&
        PhonebookArray?.map((e) => ({
          label: `${e.groupName}`,
          userid: `${e.groupName}`,
        }));
      setbulkdata5(dataarrayPhonebook);
    } else {
      setbulkdata5([]);
    }
  }, [PhonebookArray]);

  useEffect(() => {
    if (voiceplan) {
      getcallerid();
    } else {
      // alert("no caller id");
    }
  }, [voiceplan]);

  useEffect(() => {
    if (CampaignType != "") {
      getOBD();
    }
  }, [CampaignType]);

  useEffect(() => {
    if (showtextsuccessofschedule1 == true) {
      setshowtextsuccessofschedule(false);
    } else if (showtextsuccessofschedule == true) {
      setshowtextsuccessofschedule1(false);
    }
  }, [showtextsuccessofschedule1, showtextsuccessofschedule1]);

  useEffect(() => {
    if (checkicon1 == true && checkicon2 == true && checkicon3 == true) {
      setpairdisable(false);
    } else {
      setpairdisable(true);
    }
    //  else if (showtextsuccessofschedule == true) {
    //   setpairdisable(true);
    // }
  }, [checkicon1, checkicon2, checkicon3]);
  // console.log(voiceplan, "bhfskjh");
  // if single OBD
  // const OLDdata = [
  //   TransDTMFArray &&
  //     TransDTMFArray?.map((e) => ({
  //       label: `${e?.filename}`,
  //       path: `${e?.filePath}`,
  //     })),

  //   // { label: "1 Wave", year: 1994 },
  //   // { label: "2 Wave", year: 1972 },
  // ];
  const OBDdummydataOption2 = [
    { label: "Prompt set-1", year: 1994 },
    { label: "Prompt set-2", year: 1994 },
    { label: "Prompt set-3", year: 1994 },
    // { label: "Prompt set-1", year: 1994 },
  ];
  // if DTMF OBD
  const PhoneBookdummy = [
    { label: "List 1", year: 1994 },
    { label: "List 2", year: 1972 },
    { label: "List 3 ", year: 1994 },
    { label: "Own List", year: 1972 },
  ];
  const bulkbookdata = [
    { label: "Bulk Group 1", year: 1994 },
    { label: "Bulk Group 2", year: 1994 },
    { label: "Bulk Group CHD", year: 1994 },
    { label: "Bulk Group YNR", year: 1994 },
    { label: "Bulk Group KUK", year: 1994 },
  ];
  const targatedgroups = [
    { label: "Base Group-1", year: 1994 },
    { label: "YNR_male_21_above", year: 1994 },
    { label: "KUK_female_21_above ", year: 1994 },
    { label: "YNR_male_33_bellow ", year: 1994 },
    { label: "YNR_male_40_above ", year: 1994 },
    // { label: "The Godfather", year: 1972 },
  ];

  console.log("dhhdhdhddhdhd", Olddata);

  useEffect(() => {
    setCampaignType(null);
  }, [voiceplan]);
  useEffect(() => {
    setOlddata(null);
  }, [CampaignType]);

  useEffect(() => {
    getvoiceplane();
  }, []);

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <ThemeProvider theme={theme}>
          <section className="cmp">
            <div className="container-fluid">
              <div className="container-fluid_1">
                {/* <!--marquee-section--> */}
                <section className="marquee_8 modl">
                  <div className="d-flex justify-content-between">
                    <marquee>
                      This kind of ad campaign is a great wakeup call to give to
                      your target audience that is hard to miss
                    </marquee>
                  </div>
                </section>

                <section>
                  {showtextsuccessofschedule == true ? (
                    <>
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          textAlign: "center",
                          marginTop: "40px",
                        }}
                      >
                        <h2>Your campaign has been scheduled</h2>
                      </div>
                      {/* {setshowtextsuccessofschedule1(false)} */}
                    </>
                  ) : (
                    <></>
                  )}
                  {showtextsuccessofschedule1 == true ? (
                    <>
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          textAlign: "center",
                          marginTop: "40px",
                        }}
                      >
                        <h2>Your campaign has been sent</h2>
                      </div>
                      {/* {setshowtextsuccessofschedule(false)} */}
                    </>
                  ) : (
                    <></>
                  )}
                </section>

                <form
                  id="accord_8"
                  className="mt-4 m-0"
                  onSubmit={formik.handleSubmit}
                  role="form"
                >
                  {/* <div className="card shadow-none border bg_blue mt-5"> */}
                  <Accordion
                    defaultExpanded={false}
                    expanded={expandedinter === "panel1"}
                    onChange={handleChange("panel1")}
                  >
                    <AccordionSummary id="panel1d-header">
                      <Typography className="">
                        <LyricsIcon style={{ fontSize: "15px" }} /> Create Voice
                        Campaign
                      </Typography>
                      <>
                        {checkicon1 == true ? (
                          <>
                            {" "}
                            {/* <CheckCircleIcon
                              style={{
                                color: "green",
                                fontSize: "15px",
                                borderRadius: "15px",
                                backgroundColor: "#ffff",
                              }}
                            /> */}
                            {/* <Chip
                              className="green_51"
                              style={{
                                backgroundColor: "green ",
                                color: "white",
                                fontWeight: "300",
                                fontSize: "15px",
                                height: "22px",
                                width: "21px",
                                border: "2px solid white",
                              }}
                           
                            /> */}
                          </>
                        ) : (
                          <>
                            {" "}
                            {/* <CancelIcon
                              style={{
                                color: "red",
                                fontSize: "15px",
                                borderRadius: "15px",
                                backgroundColor: "#ffff",
                              }}
                            /> */}
                            {/* <Chip
                              className="pink_51"
                              style={{
                                backgroundColor: "#fb8c00 ",
                                color: "white",
                                fontWeight: "300",
                                fontSize: "15px",
                                height: "22px",
                                width: "21px",
                                border: "2px solid white",
                              }}
                            
                            /> */}
                          </>
                        )}

                        {/* <Chip
                            style={{
                              backgroundColor: "green",
                              color: "white",
                              fontWeight: "300",
                              fontSize: "15px",
                              height: " 25px",
                              border: "2px solid white",
                            }}
                            // label={`${formik?.values?.textarea1?.length}`}
                            // deleteIcon={<DoneIcon />}
                          /> */}
                      </>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        {" "}
                        <section className="sms_form_1" id="sms_form">
                          {/* <div className="row justify-content-between mx-0"> */}
                          <div className="sms_form_2 w- mx-auto  p-0 p-4">
                            <div className="row">
                              <div className="col-md-6">
                                <TextField
                                  autoComplete="on"
                                  className="ms-4 w-50"
                                  type="text"
                                  label="Event Name"
                                  name="campaignname"
                                  variant="outlined"
                                  size="small"
                                  required
                                  onChange={formik.handleChange}
                                  value={formik.values.campaignname}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched.campaignname &&
                                    Boolean(formik.errors.campaignname)
                                  }
                                  helperText={
                                    formik.touched.campaignname &&
                                    formik.errors.campaignname
                                  }
                                />
                              </div>
                              <div className="col-md-6 ">
                                {/* <FormControl required fullWidth size="small">
                                  <InputLabel id="demo-simple-select-autowidth-label">
                                    Voice Plan
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={voiceplan}
                                    onChange={(e) => {
                                      setvoiceplan(e.target.value);
                                    }}
                                    autowidth
                                    label="Campaign Type"
                                  >
                                    <MenuItem value={"Promotional"}>
                                      Promotional
                                    </MenuItem>
                                    <MenuItem value={"Transactional"}>
                                      Transactional
                                    </MenuItem>
                                  
                                  </Select>
                                </FormControl> */}
                                <FormControl required fullWidth size="small">
                                  <InputLabel id="demo-simple-select-autowidth-label">
                                    Voice Plan
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={voiceplan}
                                    onChange={(e) => {
                                      setvoiceplan(e.target.value);
                                      // setonVoiceChange(true);
                                      // handleChangevoiceplan(e, data);
                                    }}
                                    autowidth
                                    label=" Voice Plan"
                                  >
                                    {voicearray &&
                                      voicearray?.map((data) => {
                                        // console.log("aaaa", data);

                                        return (
                                          <MenuItem value={data}>
                                            {data?.obdCategory}
                                          </MenuItem>
                                        );
                                      })}

                                    {/* <MenuItem value={"Transactional"}>
                                        Transactional
                                      </MenuItem> */}
                                    {/* <MenuItem value={"Promotional-30Sec"}>
                                        Promotional-30Sec
                                      </MenuItem>
                                      <MenuItem value={"Transactional-30Sec"}>
                                        Transactional-30Sec
                                      </MenuItem> */}
                                    {/* <MenuItem value={3}>3 Prompts OBD</MenuItem> */}
                                  </Select>
                                </FormControl>
                              </div>

                              <div className="col-md-6 mt-3">
                                <FormControl required fullWidth size="small">
                                  <InputLabel id="demo-simple-select-autowidth-label">
                                    Campaign Type
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={CampaignType}
                                    onChange={(e) => {
                                      setCampaignType(e.target.value);
                                    }}
                                    // autowidth
                                    label="Campaign Type"
                                  >
                                    {/* {voiceplan.id == 1 ? ( */}
                                    {/* <> */}
                                    {voiceplan?.obdType &&
                                      voiceplan?.obdType?.map((data) => {
                                        return (
                                          <MenuItem value={data.id}>
                                            {data.obdType}
                                          </MenuItem>
                                        );
                                      })}
                                    {/* </>
                                      ) : (
                                        <></>
                                      )} */}
                                    {/* {voiceplan.id == 2 ? ( */}
                                    {/* <> */}
                                    {/* {voiceplan.obdType.map((data,index) => {
                                            return (
                                              <MenuItem key={index} value={data.id}>
                                                {data.obdType}
                                              </MenuItem>
                                            );
                                          })} */}
                                    {/* </>
                                      ) : (
                                        <></>
                                      )} */}

                                    {/* <MenuItem value="DTMF_1_Prompts">
                                        DTMF_1_Prompts
                                      </MenuItem>
                                      <MenuItem value="DTMF_2_Prompts">
                                        DTMF_2_Prompts
                                      </MenuItem>
                                      <MenuItem value="DTMF_3_Prompts ">
                                        DTMF_3_Prompts
                                      </MenuItem> */}
                                  </Select>
                                </FormControl>
                              </div>
                              <div className="col-md-6  mt-3">
                                <FormControl required fullWidth size="small">
                                  <InputLabel id="demo-simple-select-autowidth-label">
                                    Caller Id
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={callerid}
                                    onChange={(e) => {
                                      setcallerid(e.target.value);
                                    }}
                                    autowidth
                                    label="Caller Id"
                                  >
                                    {CalleridArray &&
                                      CalleridArray.map((data) => {
                                        return (
                                          <MenuItem value={data.senderId}>
                                            {data.senderId}
                                          </MenuItem>
                                        );
                                      })}
                                  </Select>
                                </FormControl>
                              </div>
                            </div>

                            {/* <div className="row mt-2"> */}

                            {/* </div> */}
                          </div>
                          {/* </div> */}
                        </section>
                        {voiceplan?.id == 2 && (
                          <span style={{ color: "red" }}>
                            {" "}
                            Promotional campaigns can be executed between 09:00
                            AM to 09:00PM as per TRAI regulations{" "}
                          </span>
                        )}
                        <div className="text-end mt-3">
                          <button
                            disabled={disableNext}
                            type="button"
                            // className="btn btn-success nx_pv m-0 opc_8"
                            className={
                              disableNext
                                ? "btn btn-success nx_pv m-0 opc_8"
                                : "btn btn-success nx_pv m-0"
                            }
                            // onClick={smsDetailsSubmit}
                            onClick={firstNext}
                          >
                            Next
                            <ArrowRightAltRoundedIcon />
                          </button>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  {/* </div> */}
                  <Accordion
                    expanded={expandedinter === "panel2"}
                    onChange={handleChange("panel2")}
                  >
                    <AccordionSummary id="panel2d-header">
                      <Typography>
                        {" "}
                        <ContactsIcon style={{ fontSize: "15px" }} /> Number
                        Selection
                      </Typography>
                      {/* <Chip
                        style={{
                          backgroundColor: checkicon2 ? "green" : "#fb8c00",
                          color: "white",
                          fontWeight: "300",
                          fontSize: "15px",
                          height: "22px",
                          width: "21px",
                          border: "2px solid white",
                        }}
                      /> */}
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <section className="sms_form_1 w-100" id="sms_form">
                          <div className="sms_form_2 w- mx-auto p-0 p-2">
                            {/* <label className="d-block text-capitalize">
                                  numbers
                                </label> */}

                            <TestRadio2 parentCallback={callbackRadio2} />

                            {(radiobutton2 == 1 ||
                              radiobutton2 == undefined) && (
                              <>
                                <div id="bxg" className="bxg66">
                                  {showradioerror == true ? (
                                    <div
                                      style={{
                                        color: "#d32f2f",
                                        textAlign: "center",
                                      }}
                                    >
                                      Please Select One Of These Options
                                    </div>
                                  ) : (
                                    <div></div>
                                  )}
                                  <div className="">
                                    <FormControl
                                      value={RadioGroupValues}
                                      onChange={handleChangeRadio}
                                    >
                                      <RadioGroup
                                        // value={RadioGroupValues1}
                                        row
                                        // onChange={handleChangeRadio}
                                        // defaultValue={1}
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                      >
                                        <div className="row">
                                          <div className="col-md-6">
                                            <div className="bx_flx">
                                              <FormControlLabel
                                                value={1}
                                                control={
                                                  <Radio required={true} />
                                                }
                                                //                   label="Own Numbers
                                                //   "

                                                className="m-0"
                                              />
                                              <label
                                                className="form-check-label "
                                                for="flexRadioDefault4"
                                              >
                                                <TextareaAutosize
                                                  id="area"
                                                  disabled={
                                                    Radiosdisabled.textarea
                                                  }
                                                  className={
                                                    formik.errors.message
                                                      ? "border-color-red w-100 w_100"
                                                      : "w-100 w_100 textarea_8 label_67"
                                                  }
                                                  textarea_8
                                                  aria-label="empty textarea"
                                                  placeholder="Enter contact number( e.g. 98xxxxxxxx) with comma separated"
                                                  name="textarea"
                                                  style={{
                                                    width: " 650px",
                                                    minHeight: "70px",
                                                    // borderColor: " #48a8dd",
                                                  }}
                                                  maxlength="100"
                                                  // value={textarea}
                                                  // required={RadioGroupValues == 1}
                                                  required
                                                  onChange={formik.handleChange}
                                                  value={formik.values.textarea}
                                                  error={
                                                    formik.touched.textarea &&
                                                    Boolean(
                                                      formik.errors.textarea
                                                    )
                                                  }
                                                  helperText={
                                                    formik.touched.textarea &&
                                                    formik.errors.textarea
                                                  }
                                                />
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-md-6">
                                            <div
                                              className="bx_flx my-"
                                              id="bx_flx"
                                            >
                                              <FormControlLabel
                                                value={2}
                                                control={<Radio />}
                                                //                   label="Targeted Numbers
                                                //   "
                                                className="m-0 ms-1"
                                              />

                                              {/* <BulkSelect
                                                parentCallback={
                                                  callbackBulkSelector
                                                }
                                                disabledval={
                                                  Radiosdisabled.bulk
                                                }
                                              /> */}
                                              <Autocomplete
                                                disablePortal
                                                disabled={Radiosdisabled.bulk}
                                                value={list}
                                                aria-required
                                                className="w-100"
                                                id="combo-box-demo"
                                                size="small"
                                                options={PhoneBookdummy}
                                                getOptionLabel={(option) =>
                                                  option.label || ""
                                                }
                                                onChange={(e, value) =>
                                                  handleChangeBulk(value)
                                                }
                                                sx={{ width: 300 }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    required
                                                    {...params}
                                                    label="My List"
                                                  />
                                                )}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row mt-2">
                                          <div className="col-md-6">
                                            <div className="bx_flx" id="bx_flx">
                                              <FormControlLabel
                                                value={3}
                                                control={<Radio />}
                                                //   label="All Robi Numbers"
                                                className="m-0 ms-1"
                                              />

                                              <Autocomplete
                                                disablePortal
                                                disabled={Radiosdisabled.bulk1}
                                                value={list2}
                                                aria-required
                                                className="w-100"
                                                id="combo-box-demo"
                                                size="small"
                                                options={bulkbookdata}
                                                getOptionLabel={(option) =>
                                                  option.label || ""
                                                }
                                                onChange={(e, value) =>
                                                  handleChangeBulk2(value)
                                                }
                                                sx={{ width: 300 }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    required
                                                    {...params}
                                                    label="My Bulk Group"
                                                  />
                                                )}
                                              />
                                            </div>
                                          </div>
                                          <div className="col-md-6">
                                            <div
                                              className="bx_flx mt-"
                                              id="bx_flx"
                                            >
                                              <FormControlLabel
                                                value={4}
                                                control={<Radio />}
                                                className="m-0 ms-1"
                                              />
                                              <>
                                                {" "}
                                                <div className="w-50">
                                                  <div
                                                    class="  input-group m-0 mb-3"
                                                    id="input_group_8"
                                                  >
                                                    <Button
                                                      disabled={
                                                        Radiosdisabled.choose
                                                      }
                                                      variant="contained"
                                                      component="label"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        boxShadow: "none",
                                                        height: "40px",
                                                        border:
                                                          "1px solid #d2d6da",
                                                        padding:
                                                          "0px 0px 0px 0px",
                                                        margin:
                                                          "0px -3px 0px 0px",
                                                      }}
                                                    >
                                                      <input
                                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                        multiple
                                                        required={
                                                          RadioGroupValues == 4
                                                        }
                                                        // required
                                                        // value={Files}
                                                        id="fileName"
                                                        type="file"
                                                        style={{
                                                          color: "#7b809a",
                                                        }}
                                                        onChange={(
                                                          e,
                                                          index
                                                        ) => {
                                                          getImage(e, index);
                                                        }}
                                                      />
                                                    </Button>
                                                  </div>
                                                </div>
                                                {Radiosdisabled.choose ==
                                                  false && (
                                                  <>
                                                    <div className="mx-3">
                                                      <span>
                                                        (Reference File)
                                                      </span>

                                                      <span>
                                                        <a
                                                          href={contactfile1}
                                                          target="_blank"
                                                          download="Reference.xlsx"
                                                          className="xlsx"
                                                        >
                                                          {/* Download Here
                                                           */}
                                                          xlsx
                                                        </a>
                                                      </span>
                                                    </div>

                                                    {/* <button
                                                      type="button"
                                                      class="btn btn-secondary text-capitalize m-0"
                                                    >
                                                      upload
                                                    </button> */}
                                                  </>
                                                )}
                                              </>
                                            </div>
                                          </div>
                                        </div>
                                      </RadioGroup>
                                    </FormControl>
                                  </div>
                                </div>
                                <div></div>
                              </>
                            )}
                            {radiobutton2 == 2 && (
                              <div className="w-50">
                                {/* <TargettedSelect
                                  parentCallback={callbackTarget}
                                  data={TargettedArray}
                                /> */}
                                <Autocomplete
                                  disablePortal
                                  // disabled={Radiosdisabled.bulk1}
                                  value={list3}
                                  aria-required
                                  className="w-100"
                                  id="combo-box-demo"
                                  size="small"
                                  options={targatedgroups}
                                  getOptionLabel={(option) =>
                                    option.label || ""
                                  }
                                  onChange={(e, value) =>
                                    handleChangeBulk3(value)
                                  }
                                  sx={{ width: 300 }}
                                  renderInput={(params) => (
                                    <TextField
                                      required
                                      {...params}
                                      label="Targeted Group"
                                    />
                                  )}
                                />
                              </div>
                            )}
                            {radiobutton2 == 3 && <></>}
                          </div>
                        </section>

                        <div className="text-end mt-3">
                          <button
                            disabled={disableNext1}
                            type="button"
                            // className="btn btn-success nx_pv m-0 opc_8"
                            className={
                              disableNext1
                                ? "btn btn-success nx_pv m-0 opc_8"
                                : "btn btn-success nx_pv m-0"
                            }
                            // onClick={smsDetailsSubmit}
                            onClick={SecondNext}
                          >
                            Next
                            <ArrowRightAltRoundedIcon />
                          </button>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    expanded={expandedinter === "panel3"}
                    onChange={handleChange("panel3")}
                  >
                    <AccordionSummary id="panel3d-header">
                      <Typography>
                        <VoiceChatIcon style={{ fontSize: "15px" }} /> Voice
                        File Selection
                      </Typography>
                      <>
                        {checkicon3 == true ? (
                          <>
                            {/* <Chip
                              style={{
                                backgroundColor: "green ",
                                color: "white",
                                fontWeight: "300",
                                fontSize: "15px",
                                height: "22px",
                                width: "21px",
                                border: "2px solid white",
                              }}
                           
                            /> */}
                          </>
                        ) : (
                          <>
                            {" "}
                            {/* <CancelIcon
                              style={{
                                color: "red",
                                fontSize: "15px",
                                borderRadius: "15px",
                                backgroundColor: "#ffff",
                              }}
                            /> */}
                            {/* <Chip
                              style={{
                                backgroundColor: "#fb8c00 ",
                                color: "white",
                                fontWeight: "300",
                                fontSize: "15px",
                                height: "22px",
                                width: "21px",
                                border: "2px solid white",
                              }}
                              // label={`${formik?.values?.textarea1?.length}`}
                              // deleteIcon={<DoneIcon />}
                            /> */}
                          </>
                        )}
                      </>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <section className="sms_form_1 w-100" id="sms_form">
                          <div className="sms_form_2 w- mx-auto p-0 p-3">
                            <div className="">
                              <div className="row">
                                <div className="col-md-6">
                                  <Autocomplete
                                    //   disablePortal
                                    //   value={list}
                                    //   disabled={disabledval}
                                    className="w-100"
                                    id="combo-box-demo"
                                    size="small"
                                    options={
                                      TransDTMFArray ? TransDTMFArray : []
                                    }
                                    // options={
                                    //   CampaignType == "Simple OBD"
                                    //     ? bulkdata4
                                    //     : OBDdummydataOption2
                                    // }
                                    getOptionLabel={(option) =>
                                      option.promptName || ""
                                    }
                                    onChange={(e, value) => setOlddata(value)}
                                    sx={{ width: 300 }}
                                    renderInput={(params) => (
                                      <TextField
                                        required
                                        {...params}
                                        label="Pre approved voice files"
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="row mt-4">
                                <div className="col-md-12">
                                  <span className="d-block font-weight-bold">
                                    Preview Audio
                                  </span>
                                  <div className="d-flex align-items-center">
                                    {Olddata?.obdFileUpload != null && (
                                      <>
                                        {" "}
                                        {Olddata?.obdFileUpload &&
                                          Olddata?.obdFileUpload?.map((e) => {
                                            return (
                                              <>
                                                <span className="d-block">
                                                  {/* {e?.filename} */}
                                                </span>

                                                <audio
                                                  className="mt-2 ms-2"
                                                  controls
                                                  src={e?.downlaodUrl}
                                                >
                                                  <a href={e?.downlaodUrl}>
                                                    Download audio
                                                  </a>
                                                </audio>
                                              </>
                                            );
                                          })}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                        <div className="text-end mt-3">
                          <button
                            disabled={disableNext2}
                            type="button"
                            // className="btn btn-success nx_pv m-0 opc_8"
                            className={
                              disableNext2
                                ? "btn btn-success nx_pv m-0 opc_8"
                                : "btn btn-success nx_pv m-0"
                            }
                            // onClick={smsDetailsSubmit}
                            onClick={ThirdNext}
                          >
                            Next
                            <ArrowRightAltRoundedIcon />
                          </button>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <section
                    className="sms_form mt-1"
                    style={{
                      boxShadow: "0px 1px 6px #00000091",
                      borderRadius: "20px",
                      /* margin-top: 53px; */
                      paddingBottom: "20px",
                    }}
                  >
                    <div className="flt_start">
                      <div className="float-start d-flex align-items-center flex-wrap"></div>
                    </div>
                    {/* {checkicon1 == true && checkicon2 == true && checkicon3 == true ?(<></>):(<></>)} */}
                    <div className="d-flex justify-content-center align-items-center mt-4">
                      <button
                        disabled={pairdisable}
                        type="button"
                        className="btn btn-success d-flex align-items-center text-capitalize btn_9 m-0 btnapprove"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal51"
                        // data-bs-toggle="modal"
                        // data-bs-target="#exampleModal1"
                      >
                        {/* <i className="fas fa-calendar-alt d-block"></i> */}
                        <span className="d-block ms-1">Test Campaign</span>
                      </button>

                      <span className="d-block text-capitalize mx-3">or</span>
                      <button
                        disabled={showsendnow1 == true ? true : pairdisable}
                        type="button"
                        className="btn btn-danger d-flex align-items-center text-capitalize btn_9 m-0 btnapprove"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal1"
                      >
                        <i className="fas fa-calendar-alt d-block"></i>
                        <span className="d-block ms-1">schedule for later</span>
                      </button>
                      <span className="d-block text-capitalize mx-3">or</span>
                      <button
                        disabled={showsendnow == true ? true : pairdisable}
                        //    ref={sendNowbutton}
                        type="submit"
                        className="btn btn-success d-flex align-items-center text-capitalize btn_9 m-0 btnapprove"
                        // data-bs-toggle="modal"
                        // data-bs-target="#exampleModal2"
                        // onClick={sendcampaign}
                      >
                        <i className="fas fa-share d-block"></i>
                        <span className="d-block ms-1">send now</span>
                      </button>
                    </div>

                    <div className="text-end ">
                      <p>View Voice Campaigns</p>
                      <Link
                        to="/dashboard/ViewVoiceCampaigns"
                        style={{
                          color: "#63B7E6",
                          marginLeft: "30px",
                        }}
                      >
                        <span>Click here !!!</span>
                      </Link>
                    </div>
                  </section>
                </form>

                {/* <!--x-form-footer-section-x--> */}
                {/* </div> */}
                {/* </section> */}
                <section className="modal_1">
                  {/* <!-- Button trigger modal --> */}
                  {/* <!-- <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
              Launch demo modal
          </button> --> */}

                  {/* <!-- Modal --> */}
                  <div
                    className="modal fade"
                    id="exampleModal51"
                    tabindex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5
                            className="modal-title text-capitalize"
                            id="exampleModalLabel"
                          >
                            Test Campaign
                          </h5>
                          <button
                            ref={cuttt}
                            type="button"
                            className="btn-close m-0 p-0"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <form onSubmit={TestCampaign}>
                          <div className="modal-body">
                            <TextField
                              autoComplete="on"
                              className="ms-4 w-50"
                              type="number"
                              label="Target Test Number"
                              value={testcampaign}
                              variant="outlined"
                              size="small"
                              required
                              onChange={(e) => {
                                settestcampaign(e.target.value);
                              }}
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 10);
                              }}
                              // value={formik.values.campaignname}
                              // onBlur={formik.handleBlur}
                              // error={
                              //   formik.touched.campaignname &&
                              //   Boolean(formik.errors.campaignname)
                              // }
                              // helperText={
                              //   formik.touched.campaignname &&
                              //   formik.errors.campaignname
                              // }
                            />
                          </div>

                          <div className="modal-footer">
                            <button
                              type="submit"
                              className="btn btn-secondary m-0"
                              // data-bs-dismiss="modal"
                              // onClick={TestCampaign}
                            >
                              ok
                            </button>
                            {/* <button
                            type="button"
                            className="btn btn-primary m-0 ms-2"
                          >
                            Save changes
                          </button> */}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  {/* ----------schedule sms later---------- */}

                  <div
                    className="modal fade "
                    id="exampleModal1"
                    tabindex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-lg ">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5
                            className="modal-title text-capitalize"
                            id="exampleModalLabel"
                          >
                            schedule sms later
                          </h5>
                          <button
                            ref={closeschdule}
                            type="button"
                            className="btn-close m-0 p-0"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <form onSubmit={scheduleapi}>
                          <div className="modal-body">
                            {/* <NativePickers parentCallback={callbackSchedule} /> */}
                            <div className="row">
                              <div className="col-md-6">
                                {voiceplan?.id == 2 ? (
                                  <>
                                    {" "}
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                      style={{ zIndex: "10px" }}
                                    >
                                      <DateTimePicker
                                        onError={(e) => {
                                          if (e) {
                                            setbuttonDisable(true);
                                          } else {
                                            setbuttonDisable(false);
                                          }
                                        }}
                                        // onAccept={() => {
                                        //   setbuttonDisable(false);
                                        // }}
                                        // onBlur={(e) => {
                                        //   handleBlur(e);
                                        // }}
                                        minDate={dayjs(new Date())}
                                        minTime={dayjs()
                                          .set("hour", 9)
                                          .set("minute", 0)
                                          .set("second", 0)}
                                        maxTime={dayjs()
                                          .set("hour", 21)
                                          .set("minute", 0)
                                          .set("second", 0)}
                                        renderInput={(props) => (
                                          <TextField
                                            required
                                            style={{ zIndex: "10px" }}
                                            {...props}
                                            helperText={
                                              "(Time Should be in Between 9:00 AM to 9:00PM)"
                                            }
                                          />
                                        )}
                                        style={{ zIndex: "10px" }}
                                        label="Select Schedule"
                                        value={value}
                                        onChange={(newValue) => {
                                          setValue(newValue);
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                      style={{ zIndex: "10px" }}
                                    >
                                      <DateTimePicker
                                        onError={(e) => {
                                          if (e) {
                                            setbuttonDisable(true);
                                          } else {
                                            setbuttonDisable(false);
                                          }
                                        }}
                                        minDate={dayjs(new Date())}
                                        renderInput={(props) => (
                                          <TextField
                                            required
                                            style={{ zIndex: "10px" }}
                                            {...props}
                                            helperText={
                                              "(Date time should be mm/dd/yyyy hh:mm (A/P)m)"
                                            }
                                          />
                                        )}
                                        style={{ zIndex: "10px" }}
                                        label="Select Schedule"
                                        value={value}
                                        onChange={(newValue) => {
                                          setValue(newValue);
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary m-0"
                              data-bs-dismiss="modal"
                              ref={closeshedule}
                            >
                              Close
                            </button>
                            <button
                              type="submit"
                              disabled={buttonDisable}
                              className="btn btn-primary m-0 ms-2"
                            >
                              Submit Campaign
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </ThemeProvider>
      </main>
    </>
  );
}
